import * as React from "react";
import type { SVGProps } from "react";
const SvgXGrey = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 25"
    {...props}
  >
    <g clipPath="url(#x-grey_svg__a)">
      <path
        fill="#B5AEAB"
        d="M18.962 1.18h3.678l-8.077 9.198L24 22.853h-7.405l-5.799-7.581-6.637 7.581H.479l8.558-9.836L0 1.18h7.59l5.238 6.925zm-1.288 19.514h2.04L6.517 3.26H4.327z"
      />
    </g>
    <defs>
      <clipPath id="x-grey_svg__a">
        <path
          fill="#fff"
          d="M0 .018h24v24H0z"
        />
      </clipPath>
    </defs>
  </svg>
);
export default SvgXGrey;
